<template>
    <a-card class="GoodsDetail">
        <div class="list">
            <div class="item" v-for="(item,index) in list" :key="index">
                <div class="top">
                    <img :src="item.img | filterUrl">
                    <div class="info" v-if="!item.customizeCourseId">
                        <h6>{{item.name}}</h6>
                        <div>
                            <span>关联状态</span>
                            <em style="font-size:14px;">未关联</em>
                        </div>
                    </div>
                    <div class="info" v-else>
                        <h6>{{item.name}}</h6>
                        <div>
                            <span>关联课程</span>
                            <em>{{item.courseName}}{{item.period ? ' - ' + item.period : ''}}</em>
                        </div>
<!--                        <div class="center">
                            <div>
                                <span>学习基数</span>
                                <span style="margin-left:10px;">{{item.studyBaseCount}}</span>
                            </div>
                            <div>
                                <span>喜欢基数</span>
                                <span style="margin-left:10px;">{{item.likeBaseCount}}</span>
                            </div>
                        </div>-->
                    </div>
                </div>
                <div class="bottom" v-if="!item.customizeCourseId" @click="bind(item)">
                    点击关联
                </div>
                <div class="bottom" v-else>
                    <span @click="cancel(item)">取消关联</span>
                    <span @click="changBind(item)">修改关联</span>
                </div>
            </div>
            <div class="item nullBox"></div>
            <div class="item nullBox"></div>
            <div class="item nullBox"></div>
        </div>
        <a-modal
            width="50%"
            :title="form.title"
            :visible="form.visible"
            destroyOnClose
            :maskClosable="true"
            :confirm-loading="form.loading"
            @ok="handleOk"
            @cancel="handleCancel">
                <a-form-model
                    ref="ruleForm"
                    :model="form.data"
                    :rules="form.rules"
                    :label-col="{span:6}"
                    :wrapper-col="{span:14}">
                    <a-form-model-item ref="course" label="选择课程" prop="customizeCourseId">
                        <a-select
                            show-search
                            v-model="form.data.customizeCourseId"
                            placeholder="请选择课程"
                            option-filter-prop="children"
                            :filter-option="filterOption"
                        >
                            <!-- <a-select-option :value="item.courseId" v-for="(item,index) in selectList" :key="item.courseId" :disabled="item.isRelated"> -->
                            <a-select-option :value="item.courseId" v-for="(item,index) in selectList" :key="item.courseId">
                                {{item.courseName}}{{item.period ? ' - ' + item.period : ''}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
<!--                    <a-form-model-item label="学习基数">
                        <a-input-number v-model="form.data.studyBaseCount" :min="0" :precision="0" style="width:100%;"/>
                    </a-form-model-item>
                    <a-form-model-item label="喜欢基数">
                        <a-input-number v-model="form.data.likeBaseCount" :min="0" :precision="0" style="width:100%;"/>
                    </a-form-model-item>-->
                </a-form-model>
        </a-modal>
    </a-card>
</template>

<script>
import $Bus from "@/pages/projectImpl/js/eventBus"
export default {
    name:'GoodsDetail',
    data () {
        return {
            form:{
                title:'关联课程',
                visible:false,
                loading:false,
                data:{
                    customizeCourseId:undefined,
                    /*studyBaseCount:null,
                    likeBaseCount:null*/
                },
                rules:{
                    customizeCourseId: [{ required: true, message: "请选择课程", trigger: "blur" }]
                }
            },
            list:[],
            selectList:[],
            itemId:'',
        }
    },
    watch:{
        'form.visible'(now){
            if(!now){
                /*this.form.data.studyBaseCount = null
                this.form.data.likeBaseCount = null*/
                this.form.data.customizeCourseId = undefined
            }
        }
    },
    created () {
        console.log('-------good')
    },
    mounted(){
        this.getList()
        this.getSelectList()
        this.setTitle()
    },
    methods: {
        getList(){
            let params = {
                spuId:this.$route.query.id,
                // pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                // pageSize: this.tableRelevant.tablePagination.pageSize,
            }
            this.$http.operate.GetSkuPageList(params)
            .then(res => {
                    this.list = res.data.items
             
            })
            .catch(err=>{

            })
        },
        getSelectList(){
            this.$http.operate.GetSkuBindCourseList()
            .then(res => {
                    this.selectList = res.data
              
            })
            .catch(err=>{

            })
        },
        setTitle(){
            const arr = ["首页","运营中心",{name: "商品管理",path: "/operate/GoodsManage"},"商品详情"];
            $Bus.$emit("pageHeaderBreadcrumb", arr);
        },
        // 取消关联
        cancel(item){
            this.itemId = item.id
            this.form.data.customizeCourseId = ''
            /*this.form.data.studyBaseCount = item.studyBaseCount
            this.form.data.likeBaseCount = item.likeBaseCount*/
            let that = this
            this.$confirm({
                title: '确认取消该商品课程关联吗？',
                content: '取消关联会导致无法推送该课程，你还要继续吗？',
                onOk() {
                    that.sKuEdit()
                },
                onCancel() {},
            });
        },
        //
        handleOk(){
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.sKuEdit()
                } else {
                }
            });
        },
        handleCancel(){
            this.$refs.ruleForm.resetFields();
            this.form.visible = false
        },
        bind(item){
            /*this.form.data.studyBaseCount = null
            this.form.data.likeBaseCount = null*/
            this.form.visible = true
            this.form.title = '关联课程'
            this.itemId = item.id
        },
        changBind(item){
            this.form.visible = true
            this.form.title = '修改关联'
            this.itemId = item.id
            this.form.data.customizeCourseId = item.customizeCourseId
            /*this.form.data.studyBaseCount = item.studyBaseCount == 0 ? null : item.studyBaseCount
            this.form.data.likeBaseCount = item.likeBaseCount == 0 ? null : item.likeBaseCount*/
        },
        sKuEdit(){
            let params = {
                customizeCourseId:this.form.data.customizeCourseId,
                /*studyBaseCount:this.form.data.studyBaseCount == null ? 0 : this.form.data.studyBaseCount,
                likeBaseCount:this.form.data.likeBaseCount == null ? 0 : this.form.data.likeBaseCount,*/
                id:this.itemId
            }
            this.$http.operate.sKuEdit(params)
            .then(res => {
                    this.getList()
                    this.getSelectList()
                    this.form.visible = false
                    this.$message.success('操作成功')
             
            })
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
    }
}
</script>

<style scoped lang="less">
/deep/ .ant-card-body{
    padding:0;
}
.GoodsDetail{
    width:100%;
    background: #F1F3F5;
    min-height:72vh;
    .list{
        width:100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item{
            width: 24%;
            margin-bottom: 20px;
            background:#fff;
            .top{
                width:100%;
                padding: 10px;
                display: flex;
                align-items: center;
                img{
                    width: 90px;
                    height:90px;
                    background:#f5f5f5;
                    flex-shrink: 0;
                    border-radius: 5px;
                }
                .info{
                    flex-grow: 1;
                    height: 90px;
                    margin-left:15px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    h6{
                        font-weight:600;
                        font-size: 14px;
                        margin: 0;
                    }
                    span{
                        font-size:14px;
                    }
                    em{
                        font-style:normal;
                        margin-left: 10px;
                        font-size:16px;
                    }
                }
            }
            .center{
                display: flex;

                div:last-child{
                    margin-left: 50px;
                }
            }
            .bottom{
                width:100%;
                height:40px;
                background:#F7F9FA;
                display: flex;
                justify-content: center;
                align-items:center;
                font-size:14px;
                cursor: pointer;
                span{
                    width:50%;
                    text-align:center;
                }
                span:nth-child(1){
                    border-right:1px solid #ccc;
                }
            }
        }
        .nullBox{
            height:0;
            border:none;
        }
    }
}
</style>
